{
  "version": 1,
  "asset_id": "dbb40ee0-f402-418a-86e5-b91e0852e133",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/dbb40ee0-f402-418a-86e5-b91e0852e133/antiquing-dry.mp4",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/dbb40ee0-f402-418a-86e5-b91e0852e133/antiquing-dry.mp4",
  "original_filename": "antiquing-dry.mp4",
  "size": 2239049,
  "content_type": "video/mp4",
  "created_at": "2026-09-11T23:20:34Z"
}
